"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var fa_1 = require("react-icons/fa");
var react_bootstrap_1 = require("react-bootstrap");
require("../assets/css/custom-autocomplete-input.css");
var CustomInput_1 = __importStar(require("./CustomInput"));
var CustomAutocompleteInput = function (_a) {
    var id = _a.id, name = _a.name, label = _a.label, value = _a.value, placeholder = _a.placeholder, _b = _a.required, required = _b === void 0 ? false : _b, description = _a.description, errorMessage = _a.errorMessage, conditionalErrorVisible = _a.conditionalErrorVisible, conditionalErrorMessage = _a.conditionalErrorMessage, _c = _a.disabled, disabled = _c === void 0 ? false : _c, tooltip = _a.tooltip, _d = _a.className, className = _d === void 0 ? '' : _d, style = _a.style, _e = _a.lang, lang = _e === void 0 ? 'tr-TR' : _e, fetchOptions = _a.fetchOptions, onSelect = _a.onSelect;
    var _f = (0, react_1.useState)(value || ''), inputValue = _f[0], setInputValue = _f[1];
    var _g = (0, react_1.useState)([]), options = _g[0], setOptions = _g[1];
    var _h = (0, react_1.useState)(false), isDropdownVisible = _h[0], setIsDropdownVisible = _h[1];
    var _j = (0, react_1.useState)(-1), highlightedIndex = _j[0], setHighlightedIndex = _j[1];
    var dropdownRef = (0, react_1.useRef)(null);
    // Input değeri değişince fetchOptions ile seçenekleri getiriyoruz.
    var handleInputChange = function (e) { return __awaiter(void 0, void 0, void 0, function () {
        var value, fetchedOptions, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    value = e.target.value;
                    setInputValue(value);
                    if (!value) return [3 /*break*/, 5];
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, fetchOptions(value)];
                case 2:
                    fetchedOptions = _a.sent();
                    setOptions(fetchedOptions);
                    setIsDropdownVisible(fetchedOptions.length > 0);
                    setHighlightedIndex(-1); // Her aramada highlight'ı resetliyoruz.
                    return [3 /*break*/, 4];
                case 3:
                    error_1 = _a.sent();
                    console.error('Fetch options failed:', error_1);
                    setOptions([]);
                    setIsDropdownVisible(false);
                    return [3 /*break*/, 4];
                case 4: return [3 /*break*/, 6];
                case 5:
                    setOptions([]);
                    setIsDropdownVisible(false);
                    _a.label = 6;
                case 6: return [2 /*return*/];
            }
        });
    }); };
    // Bir seçenek tıklandığında
    var handleOptionClick = function (option) {
        onSelect(option);
    };
    var handleReset = function () {
        setIsDropdownVisible(false);
        setInputValue('');
    };
    // Klavyeden gelen tuşlara tepki veren handler
    var handleKeyDown = function (e) {
        if (!isDropdownVisible)
            return;
        if (e.key === 'ArrowDown') {
            e.preventDefault();
            setHighlightedIndex(function (prev) { return (prev < options.length - 1 ? prev + 1 : 0); });
        }
        else if (e.key === 'ArrowUp') {
            e.preventDefault();
            setHighlightedIndex(function (prev) { return (prev > 0 ? prev - 1 : options.length - 1); });
        }
        else if (e.key === 'Enter') {
            e.preventDefault();
            if (highlightedIndex >= 0 && highlightedIndex < options.length) {
                handleOptionClick(options[highlightedIndex]);
            }
        }
        else if (e.key === 'Escape') {
            setIsDropdownVisible(false);
        }
    };
    // Vurgulanan öğenin görünür olmasını sağlamak için scrollIntoView kullanıyoruz.
    (0, react_1.useEffect)(function () {
        if (dropdownRef.current) {
            var highlightedItem = dropdownRef.current.querySelector('.autocomplete-option.highlighted');
            if (highlightedItem) {
                highlightedItem.scrollIntoView({ block: 'nearest' });
            }
        }
    }, [highlightedIndex]);
    // Fonksiyon, eşleşen kısmı <mark> etiketiyle vurguluyor.
    var highlightMatch = function (option, query) {
        if (!query)
            return option;
        var collator = new Intl.Collator(lang, { sensitivity: 'accent' });
        var startIndex = -1;
        for (var i = 0; i <= option.length - query.length; i++) {
            var substring = option.substring(i, i + query.length);
            if (collator.compare(substring, query) === 0) {
                startIndex = i;
                break;
            }
        }
        if (startIndex === -1) {
            return option;
        }
        var beforeMatch = option.slice(0, startIndex);
        var match = option.slice(startIndex, startIndex + query.length);
        var afterMatch = option.slice(startIndex + query.length);
        return "".concat(beforeMatch, "<mark>").concat(match, "</mark>").concat(afterMatch);
    };
    return (react_1.default.createElement("div", { className: "autocomplete-container ".concat(className), style: style },
        react_1.default.createElement("div", { className: "form-group" },
            react_1.default.createElement(react_bootstrap_1.OverlayTrigger, { placement: "bottom", overlay: tooltip ? react_1.default.createElement(react_bootstrap_1.Tooltip, { id: "tooltip-".concat(id) }, tooltip) : react_1.default.createElement(react_1.default.Fragment, null) },
                react_1.default.createElement(CustomInput_1.default, { id: id, name: name, label: label, inputType: CustomInput_1.InputType.TEXT, value: inputValue, onChange: handleInputChange, onKeyDown: handleKeyDown, placeholder: placeholder, buttonIcon: react_1.default.createElement(fa_1.FaTimes, null), buttonClass: "btn btn-danger bg-soft-danger", buttonOnClick: handleReset, className: "form-control", required: required, disabled: disabled })),
            isDropdownVisible && (react_1.default.createElement("div", { className: "autocomplete-dropdown", ref: dropdownRef }, options.map(function (option, index) { return (react_1.default.createElement("div", { key: index, className: "autocomplete-option ".concat(index === highlightedIndex ? 'highlighted' : ''), onClick: function () { return handleOptionClick(option); }, dangerouslySetInnerHTML: {
                    __html: highlightMatch(option, inputValue),
                } })); }))),
            errorMessage && (react_1.default.createElement("div", { className: "invalid-feedback text-danger mt-2" },
                react_1.default.createElement(fa_1.FaExclamationTriangle, { className: "me-1" }),
                errorMessage)),
            conditionalErrorVisible && conditionalErrorMessage && (react_1.default.createElement("div", { className: "conditional-error-message text-warning mt-2" },
                react_1.default.createElement(fa_1.FaExclamationTriangle, { className: "me-1" }),
                conditionalErrorMessage)),
            description && (react_1.default.createElement("div", { className: "form-description text-secondary mt-2" },
                react_1.default.createElement(fa_1.FaInfoCircle, { className: "me-1" }),
                description)))));
};
exports.default = CustomAutocompleteInput;
